module.exports = __webpack_public_path__ + "static/media/landing-featured-seller.522a1b85.png";